module.exports = __webpack_public_path__ + "static/media/RFID 2.b2b7aaf6.png";